import React from 'react'
import styles from './styles.module.scss'
import Icon from 'srcReact/components/icons/Icon'

function BoxNumber({ highlight, text, variation, image, className }) {
  return (
    <div className={`${styles.box} ${className}`}>
      <p className={styles.highlight}>{highlight || '-'}</p>
      <p className={styles.text}>{text}</p>
      <p className={`${styles.variation} ${parseInt(variation) < 0 ? styles.red : styles.green}`}>
        <Icon name='grow' size='small' /> {variation}
      </p>
      <img className={styles.image} src={`${config.assetUrl}/images/${image}.svg`} />
    </div>
  )
}

export default BoxNumber
